import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Helmet } from "react-helmet-async";
import { TrendingUp, BookOpen, FileText, Target, Mail, BarChart3 } from "lucide-react";

const subServices = ["Course Creation", "PDF Courses", "Marketing"];

const features = [
  {
    icon: BookOpen,
    title: "Course Creation",
    description: "Full online course development from curriculum to production and launch.",
  },
  {
    icon: FileText,
    title: "PDF Courses",
    description: "Beautifully designed PDF courses, guides, and lead magnets that convert.",
  },
  {
    icon: Target,
    title: "Marketing Strategy",
    description: "Data-driven marketing strategies to reach and convert your ideal customers.",
  },
  {
    icon: Mail,
    title: "Email Marketing",
    description: "Email campaigns that nurture leads and turn subscribers into buyers.",
  },
  {
    icon: BarChart3,
    title: "Analytics & Reporting",
    description: "Track performance with clear, actionable insights and reporting.",
  },
  {
    icon: TrendingUp,
    title: "Growth Strategy",
    description: "Comprehensive growth plans to scale your digital presence and revenue.",
  },
];

const benefits = [
  {
    title: "Passive Income",
    description: "Create digital products that generate revenue while you sleep.",
  },
  {
    title: "Expert Positioning",
    description: "Establish yourself as an authority in your niche with professional courses.",
  },
  {
    title: "Scalable Business",
    description: "Digital products scale infinitely without additional time investment.",
  },
  {
    title: "Full Support",
    description: "From idea to launch, we handle everything for your digital products.",
  },
];

const process = [
  {
    title: "Planning",
    description: "Mapping out your course content and marketing strategy.",
  },
  {
    title: "Creation",
    description: "Developing high-quality course materials and marketing assets.",
  },
  {
    title: "Launch",
    description: "Strategic launch with email sequences and promotional campaigns.",
  },
  {
    title: "Scale",
    description: "Ongoing optimization and scaling of your digital products.",
  },
];

export default function DigitalMarketing() {
  return (
    <>
      <Helmet>
        <title>Digital Marketing Services | SEO, PPC & Online Advertising | Barton</title>
        <meta name="description" content="Results-driven digital marketing for small businesses. SEO, Google Ads, Facebook Ads, and email marketing campaigns that deliver real ROI." />
        <meta property="og:title" content="Digital Marketing Services | Barton" />
        <meta property="og:description" content="Results-driven digital marketing. SEO, Google Ads, Facebook Ads, and email marketing that delivers ROI." />
        <meta property="og:url" content="https://barton.uk/services/digital-marketing" />
        <meta property="og:image" content="https://barton.uk/og-image.png" />
        <meta name="twitter:title" content="Digital Marketing Services | Barton" />
        <meta name="twitter:description" content="SEO, Google Ads, Facebook Ads, and email marketing that delivers ROI." />
        <meta name="twitter:image" content="https://barton.uk/og-image.png" />
      </Helmet>
      <ServicePageTemplate
        title="Digital Marketing"
        subtitle="Scale Your Business Online"
        description="From course creation to marketing strategy, we help you build and sell digital products that generate passive income and establish your expertise."
        image="https://images.unsplash.com/photo-1533750349088-cd871a92f312?w=800&q=80"
        icon={TrendingUp}
        features={features}
        benefits={benefits}
        process={process}
        subServices={subServices}
        ctaText="Get In Touch"
        accentColor="blue"
      />
    </>
  );
}
